function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 41 23"
}, props), React.createElement("path", {
  d: "M40.158 4.514l-17.923 17.87a1.888 1.888 0 01-.696.453 2.44 2.44 0 01-.808.141 2.437 2.437 0 01-.811-.122 1.889 1.889 0 01-.708-.435L.808 4.99C.298 4.508.04 3.9.031 3.167.02 2.433.284 1.802.817 1.27c.534-.53 1.16-.8 1.88-.808.72-.009 1.353.245 1.899.763l16.056 15.206L36.335.842c.497-.496 1.115-.747 1.852-.756a2.66 2.66 0 011.927.762c.546.517.823 1.125.832 1.823.008.699-.255 1.313-.788 1.843z",
  fill: "#909090"
})));